import { ApiError } from "./api";

export interface VerifyFailure {
  /** True when the challenge is spent and the user must sign in again. */
  restart: boolean;
  /** The reissued challenge token when the server allowed a retry. */
  nextChallengeToken: string | null;
  attempts: number;
}

/**
 * Decides what a failed `/v1/auth/2fa/verify` call means for the login UI.
 * The server reports attempt counts in the error's `details`; anything that
 * does not carry them (expired challenge, network error) restarts login.
 */
export function verifyFailure(error: unknown): VerifyFailure {
  if (error instanceof ApiError) {
    const details = error.details as
      | { attempts?: number; challengeToken?: string }
      | null
      | undefined;
    if (details && typeof details.attempts === "number") {
      const attempts = details.attempts;
      const nextChallengeToken = details.challengeToken ?? null;
      return { restart: nextChallengeToken === null, nextChallengeToken, attempts };
    }
  }
  return { restart: true, nextChallengeToken: null, attempts: 0 };
}
